<script setup lang="ts">
import type { Testimonial } from '@/types/landing'

interface Props {
  testimonials: Testimonial[]
}

const props = defineProps<Props>()
</script>

<template>
  <section id="testimonials" class="bg-white py-16 md:py-20" aria-label="用户证言">
    <div class="mx-auto max-w-[1200px] px-6">
      <!-- 标题 -->
      <h2 class="mb-10 text-center text-2xl font-semibold text-[#1D2129] md:text-3xl">
        他们正在使用智台账
      </h2>

      <!-- 证言卡片 -->
      <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
        <article
          v-for="item in props.testimonials"
          :key="item.id"
          class="group flex flex-col rounded-2xl border border-[#E5E6EB] bg-white p-6 transition-all duration-300 ease-out hover:-translate-y-0.5 hover:shadow-md"
        >
          <!-- 引号 -->
          <div class="mb-3 text-3xl font-serif text-indigo-300">"</div>

          <!-- 证言内容 -->
          <blockquote class="mb-6 flex-1">
            <p class="text-sm leading-relaxed text-[#4E5969] md:text-base">
              {{ item.quote }}
            </p>
          </blockquote>

          <!-- 来源信息 -->
          <footer class="flex items-center gap-3 border-t border-[#F2F3F5] pt-4">
            <!-- 头像 -->
            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-indigo-100 to-purple-100 text-sm font-medium text-indigo-700">
              {{ item.author.charAt(0) }}
            </div>
            <div>
              <cite class="not-italic block text-sm font-medium text-[#1D2129]">
                {{ item.author }}
              </cite>
              <span class="text-xs text-[#86909C]">{{ item.role }} · {{ item.org }}</span>
            </div>
          </footer>
        </article>
      </div>
    </div>
  </section>
</template>
